import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import BudgetReconciliationBillAlert from 'tio-employee/components/budget-reconciliation-bill-alert';
import AlertBanner from 'tio-ui/components/alert-banner';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import pageTitle from 'ember-page-title/helpers/page-title';

export default class IdrDashboardLayout extends Component {
  @service declare router: RouterService;

  // The promoted sort-plans dashboard shows its own present-tense bill alert
  // (mirroring strategy-finder-0726) on the landing page, questionnaire, and
  // results. The legacy consolidation/repayment recommendation pages keep the
  // shared future-tense BudgetReconciliationBillAlert.
  get show0726BillAlert() {
    const routeName = this.router.currentRouteName ?? '';
    return (
      routeName === 'authenticated.idr.dashboard.index' ||
      routeName.startsWith('authenticated.idr.dashboard.questionnaire') ||
      routeName.startsWith('authenticated.idr.dashboard.results')
    );
  }

  <template>
    {{pageTitle (t "idr.default")}}
    <VStack>
      <PageHeader @title={{t "idr.default"}}>
        <:below>
          {{#if this.show0726BillAlert}}
            <AlertBanner @intent="info" data-test-idr-0726-bill-alert>
              <h2 class="text-base">
                <strong>{{t "idr_dashboard_0726.bill_alert.header"}}</strong>
              </h2>
              <p>{{t "idr_dashboard_0726.bill_alert.body"}}</p>
            </AlertBanner>
          {{else}}
            <BudgetReconciliationBillAlert />
          {{/if}}
        </:below>
      </PageHeader>
      {{outlet}}
    </VStack>
  </template>
}
